import React, { useEffect, useRef, useState } from 'react';
import ButtonTooltip from '../../components/Inputs/ButtonTooltip';
import { api } from '../../components/api/api';
import { TiPlus, TiMinus, TiTrash, TiPencil } from "react-icons/ti";
import { Col, Row } from 'react-bootstrap';
import ModalMateriaPrima from './ModalMateiraPrima';
import { Pergunta, Alert, AlertErro } from '../../util/Alertas';
import { FaDownload, FaHistory } from "react-icons/fa";
import ModalLogMateiraPrima from './ModalLogMateriaPrima';
import { exportCSV } from '../../util/Excel';

function MateriaPrima() {
    const modalRef = useRef();
    const logRef = useRef();
    const [materiaPrima, setMateriaPrima] = React.useState([]);
    const [name, setName] = useState('');

    const GetTodasMateriasPrimas = () => {
        api.get("api/MateriaPrima", res => {
            setMateriaPrima(res.data);
        })
    }

    useEffect(() => {
        GetTodasMateriasPrimas();
    }, [])

    const onDelete = async (id) => {
        if (await Pergunta('Deseja Realmente EXCLUIR essa matéria prima?')) {
            api.post(`api/MateriaPrima/Delete/${id}`, {}, res => {
                GetTodasMateriasPrimas();
                Alert("Matéria prima excluida com sucesso!");
            }, err => AlertErro(err))
        }
    }

    return (
        <section className='app'>
            <ModalMateriaPrima
                Reload={GetTodasMateriasPrimas}
                ref={modalRef} />
            <ModalLogMateiraPrima
                ref={logRef}
            />
            <div className="content">
                <h2>Materias Primas:</h2>
                <small>Filtro:</small>
                <Row>
                    <Col md={8}>
                        <label htmlFor="">Buscar por Nome</label>
                        <input className='form-control' value={name} onChange={e => setName(e.target.value)} type="text" name="" id="" />
                    </Col>
                    <Col style={{ marginTop: '20px' }}>
                        <button onClick={e => exportCSV(materiaPrima.filter(x => x.nome.toUpperCase().includes(name.toUpperCase())),'MateriasPrimas.csv')} className='btn btn-success'>Download <FaDownload size={23} color='#fff' /></button>
                    </Col>
                </Row>
                <br />
                <button onClick={e => modalRef.current.novo()} className='btn btn-primary'>Adicionar Nova Matéria prima <TiPlus size={23} color='#fff' /></button>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Quantidade</th>
                            <th>Valor Un.</th>
                            <th>Editar.</th>
                            <th>Entrada</th>
                            <th>Saída</th>
                            <th>Excluir</th>
                            <th>Logs</th>
                        </tr>
                    </thead>
                    <tbody>
                        {materiaPrima.filter(x => x.nome.toUpperCase().includes(name.toUpperCase())).map(x => (<tr key={x.id}>
                            <td data-label="Nome">{x.nome}</td>
                            <td data-label="Quantidade">{x.quantidade}</td>
                            <td data-label="Valor Un">R$ {x.valorUn.toFixed(2).replaceAll('.', ',')}</td>
                            <td data-label="Editar">
                                <ButtonTooltip
                                    text={"Editar Materia Prima"}
                                    textButton={<TiPencil size={23} color='#fff' />}
                                    className='btn btn-success'
                                    top={true}
                                    onClick={() => modalRef.current.edit(x)}
                                />
                            </td>
                            <td data-label="Entrada">
                                <ButtonTooltip
                                    text={"Informar Entrada"}
                                    textButton={<TiPlus size={23} color='#fff' />}
                                    className='btn btn-success'
                                    top={true}
                                    onClick={() => modalRef.current.edit(x, true, false)}
                                />
                            </td>
                            <td data-label="Saída">
                                <ButtonTooltip
                                    text={"Informar Saída"}
                                    textButton={<TiMinus size={23} color='#fff' />}
                                    className='btn btn-success'
                                    top={true}
                                    onClick={() => modalRef.current.edit(x, false, true)}
                                />
                            </td>
                            <td data-label="Excluir">
                                <ButtonTooltip
                                    text={"Excluir Materia Prima"}
                                    textButton={<TiTrash size={23} color='#fff' />}
                                    className='btn btn-danger'
                                    top={true}
                                    onClick={() => onDelete(x.id)}
                                />
                            </td>
                            <td data-label="Logs">
                                <ButtonTooltip
                                    text={"Ver Logs Materia Prima"}
                                    textButton={<FaHistory size={23} color='#fff' />}
                                    className='btn btn-danger'
                                    top={true}
                                    onClick={() => logRef.current.open(x.id)}
                                />
                            </td>
                        </tr>))}
                        {materiaPrima.length === 0 && <tr>
                            <td colSpan="10"><span>Não foi encontrado nenhuma materia prima...</span></td>
                        </tr>}
                    </tbody>
                </table>
            </div>
        </section>
    );
}

export default MateriaPrima;